module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-app', [_c('side-bar'), _c('v-main', {
    style: (!_vm.$vuetify.theme.dark ? ("background: " + (_vm.$vuetify.theme.themes.light.background)) : ''),
    attrs: {
      "transition": "slide-y-transition"
    }
  }, [_c('router-view')], 1), _c('notifications', {
    class: _vm.isMovil ? 'width-full' : '',
    attrs: {
      "position": "top right"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(props) {
        return [_c('v-alert', {
          staticClass: "elevation-2 py-3 ma-1 animated fadeInRight faster",
          attrs: {
            "dense": "dense",
            "border": "left",
            "type": props.item.type
          }
        }, [_c('v-row', {
          attrs: {
            "align": "center"
          }
        }, [_c('v-col', {
          staticClass: "grow"
        }, [_c('small', {
          staticClass: "font-size-11 font-weight-700"
        }, [_vm._v(_vm._s(props.item.text))])])], 1)], 1)]
      }
    }])
  }), (_vm.transaction.isProceso) ? _c('loading-transaction', {
    attrs: {
      "label": _vm.transaction.message
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2beaeedc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Dispatcher_App.vue
// module id = 488
// module chunks = 1